import React, { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { ScheduleCalendar, SectionCard } from "components/admin";
import { workspaceApi } from "pages/app/workspace/services";
import { SchoolPlayerProfileTabProps } from "pages/app/workspace/school-player-profile/school-player-profile.types";

export const SchoolPlayerScheduleTab: React.FC<SchoolPlayerProfileTabProps> = ({ playerId }) => {
  const calendarQuery = useQuery({
    queryKey: ["school-player-profile-calendar", playerId],
    queryFn: () => workspaceApi.athletes.getCalendarEvents(playerId),
    enabled: Boolean(playerId),
  });

  const playerCalendarItems = useMemo(
    () =>
      (calendarQuery.data || []).map((event: any, index: number) => ({
        category: "event" as const,
        details: event.details || event.description || "No event details provided yet.",
        id: event.id || `player-event-${index}`,
        location: event.location || event.venue_name || "Location pending",
        start: event.start_date || event.start || event.date || event.scheduled_at,
        end:
          event.end_date ||
          event.end ||
          event.date ||
          event.scheduled_at ||
          event.start_date ||
          event.start,
        status: event.status,
        title: event.name || event.title || "Untitled event",
      })),
    [calendarQuery.data],
  );

  return (
    <SectionCard
      subtitle="Upcoming player events from the athlete calendar endpoint."
      title="Calendar Events"
    >
      <ScheduleCalendar
        emptyDescription="Upcoming player events will appear here once they exist."
        emptyTitle="No calendar events"
        isLoading={calendarQuery.isLoading}
        items={playerCalendarItems}
      />
    </SectionCard>
  );
};
